import React from 'react';
import { Round } from '../classes/Round';
import { RoundBlackCard } from '../classes/RoundBlackCards';
import { Player } from '../classes/Player';
import { getBlackCardText } from '../utils/TextsUtils';

interface FaceUpCardLargeInterface {
    playerId: number;
    currentRound: Round;
    roundBlackCard: RoundBlackCard;
    criminal: Player;
    handleCloseOpenedBlackCard: any;
}

function FaceUpCardLarge({playerId, currentRound, roundBlackCard, criminal, handleCloseOpenedBlackCard}: FaceUpCardLargeInterface) {
    const closeIcon = require("../images/close.png");
    const announcements = require("../images/announcementsBlack.png");

    const handleClose = () => {
        handleCloseOpenedBlackCard();
    }

    return (
        <div className="faceUpCardWrapperLarge">
            <div className="faceUpCardInnerWrapperLarge">
                {playerId === currentRound.judge && <div className="faceUpCardCloseWrapperLarge" tabIndex={0} onClick={handleClose} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleClose();
                    }
                }}>
                    <img className="faceUpCardCloseIconLarge" src={closeIcon} alt="close"/>
                </div>}
                <div className="faceUpCardReadCardAloudWrapperLarge">
                    <div className="faceUpCardReadCardAloudLarge">Read Card Aloud</div>
                    <img className="faceUpCardReadCardAloudIconLarge" src={announcements} alt="read card aloud"/>
                </div>
                <div className="faceUpCardTextLarge">
                    {getBlackCardText(roundBlackCard.blackCardIdx, criminal.name, criminal.gender)}
                </div>
            </div>
        </div>
    );
};

export default FaceUpCardLarge;